module.exports = __webpack_public_path__ + "img/svg/danger.9f310224f358c1213aadb82257a17c5d.svg";